const frameStyle = { width: '100%', height: '60vh', border: 0 };
const textStyle = { whiteSpace: 'pre-wrap', maxHeight: '60vh', overflow: 'auto' };

/** One logged email's body: a template email is HTML; a plain-text one (no template) is shown as written. */
export default function EmailBody({ email, title }) {
    if (!email.template) return <pre style={textStyle}>{email.body}</pre>;
    // an empty sandbox runs no scripts and opens no forms, so a stored email cannot act inside the admin page
    return <iframe title={title} sandbox="" srcDoc={email.body} style={frameStyle} />;
}
